<template>
    <div>
        <h1 style="text-align: center">Mitglieder</h1>
<!--        <b-button variant="primary" v-b-modal.create-staff-modal @click="clearForm">Anlegen</b-button>-->
        <b-button variant="primary" v-b-modal.import-members-modal @click="clearForm">Excel Import</b-button>

        <member-table :data-url="'members'" :key="componentKey"/>

        <b-modal id="import-members-modal" title="Mitglieder Import">

            <b-form>
                <b-form style="width: 300px;">
                    <b-form-group
                        label="Excel Datei:"
                        label-for="excel-file"
                    >
                        <b-form-file
                            id="excel-file"
                            v-model="importFile"
                            :state="Boolean(importFile)"
                            accept=".xlsx"
                            placeholder="Datei auswählen"
                            drop-placeholder="Datei hier ablegen..."
                            browse-text="Durchsuchen"
                        ></b-form-file>
                    </b-form-group>
                </b-form>
            </b-form>

            <template v-slot:modal-footer="{ ok, cancel}">
                <b-button size="sm" variant="danger" @click="cancel()">
                    Abbrechen
                </b-button>

                <b-button :disabled="!Boolean(importFile)" size="sm" variant="success" @click="importMembers">
                    Importieren
                </b-button>

            </template>
        </b-modal>

        <b-modal id="import-success-modal" title="Import abgeschlossen" size="lg">

            <div v-for="message in importMessage" :key="message">
                <ul>
                    <li>
                        <!--                    [Zeile: {{ message.number['current column'] }}, Spalte: {{ message.number['current row'] }}]: -->
                        {{ message }}
                    </li>
                </ul>
            </div>
        </b-modal>

    </div>
</template>

<script>
    // import gql from "graphql-tag";

    import MemberTable from "../components/MemberTable";

    export default {
        name: "Members",
        components: {MemberTable},
        mounted() {
        },
        methods: {
            importMembers() {

                let formData = new FormData();
                let vThis = this;

                formData.append("import_excel", this.importFile);

                this.$api.post('members/import', formData, {
                    // onUploadProgress(progressEvent) {
                    //     vThis.value = (progressEvent.loaded * 100) / progressEvent.total;
                    // },
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then(function (response) {
                    vThis.componentKey += 1
                    vThis.$bvModal.hide('import-members-modal');
                    vThis.importFile = null;
                    vThis.importMessage = [];

                    // console.log(response.data)
                    //
                    // for (dataSet of response.data) {
                    //     console.log(dataSet)
                    //     if (dataSet.length > 0) {
                    //         for (data of dataSet) {
                    //             console.log(data)
                    //             vThis.importMessage.push(data.errorMsg)
                    //         }
                    //     }
                    // }

                    vThis.importMessage = response.data

                    vThis.$bvModal.show('import-success-modal');
                });
            },
            clearForm: function () {
                this.edit_id = false;
                this.formData = {
                    name: '',
                    email: ''
                };
            },
            getData: function () {
                this.$api.get('members')
                    .then(response => (this.members = response.data))
            },
        },
        data() {
            return {
                formData: {
                    name: '',
                    email: ''
                },
                edit_id: false,
                importFile: null,
                importMessage: [],
                componentKey: 0
            }
        }

    }
</script>

